import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { useI18n } from '../i18n';
import { FormFileUpload } from './File/FormFileUpload';
export function FormFile({ name, validation, label, helperText, value: fieldValue, onChange: fileOnChange, ...rest }) {
    const intl = useI18n();
    const { control, setError } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, render: ({ field: { onChange, value }, fieldState: { error, invalid }, }) => {
            return (_jsxs("div", { children: [label ? (_jsx(FormControl.Label, { htmlFor: name, children: label }, void 0)) : null, _jsxs("div", { className: "mt-1", children: [_jsx(FormFileUpload, { ...rest, invalid: invalid, value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : value, onChange: value => {
                                    onChange(value);
                                    if (typeof fileOnChange === 'function') {
                                        fileOnChange(value);
                                    }
                                }, onError: ({ message, fileName }) => {
                                    setError(name, {
                                        type: 'validate',
                                        message: fileName
                                            ? intl.$t({
                                                id: 'Generics.UploadFailedWithMessage',
                                                defaultMessage: 'Could not upload {file_name}: {err_message}',
                                            }, { file_name: fileName, err_message: message })
                                            : message,
                                    });
                                } }, void 0), _jsx(FormControl.Meta, { ...{
                                    helperText,
                                    invalid,
                                    error: error === null || error === void 0 ? void 0 : error.message,
                                } }, void 0)] }, void 0)] }, void 0));
        } }, void 0));
}
//# sourceMappingURL=FormFile.js.map